// services/problemCategoryService.ts
import axios from "axios";
import { apiClient } from "../utils/apiClient";
import { PaginatedResponse } from "../types/core/PaginatedResponse";
import { CreateProblemCategoryData, ProblemCategory, UpdateProblemCategoryData } from "../types/features/ProblemCategory";
import { MAIN_API_URL } from "../config/api";

export const problemCategoryService = {
  // Liste paginée des catégories
  async getCategories(
    page: number = 1,
    perPage: number = 20,
    filters?: { search?: string; is_active?: boolean }
  ): Promise<PaginatedResponse<ProblemCategory>> {
    const response = await apiClient.get<PaginatedResponse<ProblemCategory>>('/categories-problem', {
      params: { page, per_page: perPage, ...filters },
    });
    return response.data;
  },

  // Récupérer une catégorie par ID
  async getCategoryById(id: string): Promise<ProblemCategory> {
    const response = await apiClient.get<ProblemCategory>(`/categories-problem/${id}`);
    return response.data;
  },

  // Créer une catégorie
  async createCategory(data: CreateProblemCategoryData): Promise<ProblemCategory> {
    const response = await apiClient.post<ProblemCategory>('/categories-problem', data);
    return response.data;
  },

  // Mettre à jour une catégorie
  async updateCategory(id: string, data: UpdateProblemCategoryData): Promise<ProblemCategory> {
    const response = await apiClient.put<ProblemCategory>(`/categories-problem/${id}`, data);
    return response.data;
  },

  // Supprimer une catégorie
  async deleteCategory(id: string): Promise<void> {
     try {
      await apiClient.delete(`/categories-problem/${id}`);
     } catch (error: any) {
      console.log(error.response)
     }
  },

  // Réordonner les catégories
  async reorderCategories(categories: string[]): Promise<void> {
    await apiClient.post('/categories-problem/reorder', { categories });
  },

  // Récupérer les catégories publiques (sans auth)
  async getPublicCategories(entrepriseId: string): Promise<ProblemCategory[]> {
   try {
     const response = await axios.get<ProblemCategory[]>(`${MAIN_API_URL}/categories-problem/public/${entrepriseId}`);
    return response.data;
   } catch (error) {
    return []
   }
  }
};